import { render, staticRenderFns } from "./SelectElementDialog.vue?vue&type=template&id=361f8c18&scoped=true"
import script from "./SelectElementDialog.vue?vue&type=script&lang=ts"
export * from "./SelectElementDialog.vue?vue&type=script&lang=ts"
import style0 from "./SelectElementDialog.vue?vue&type=style&index=0&id=361f8c18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f8c18",
  null
  
)

export default component.exports